"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Routes;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRhumb = require("react-rhumb");

var _DocumentHead = _interopRequireDefault(require("ecosystem-marketplace-core/components/portals/DocumentHead"));

var _PrerenderReady = _interopRequireDefault(require("ecosystem-marketplace-core/components/prerender/PrerenderReady"));

var CategorySlug = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/urlSlugs/CategorySlug"));

var SuperCategorySlug = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/urlSlugs/SuperCategorySlug"));

var StorefrontCollectionSlug = _interopRequireWildcard(require("../constants/StorefrontCollectionSlug"));

var _auth = require("../selectors/auth");

var _withCategoryParamValidation = _interopRequireDefault(require("../decorators/withCategoryParamValidation"));

var _Storefront = _interopRequireDefault(require("../containers/Storefront"));

var _DetailContainer = _interopRequireDefault(require("../containers/detail/DetailContainer"));

var _AllCollections = _interopRequireDefault(require("../containers/storefront/AllCollections"));

var _SearchResults = _interopRequireDefault(require("../containers/storefront/SearchResults"));

var _NotFoundError = _interopRequireDefault(require("./error/NotFoundError"));

var _AllReviewsPage = _interopRequireDefault(require("../containers/detail/AllReviewsPage"));

var _DetailPage = _interopRequireDefault(require("./detail/DetailPage"));

var categorySlugRegExp = Object.values(CategorySlug).join('|');
var collectionSlugRegExp = Object.values(StorefrontCollectionSlug).join('|');
var superCategorySlugRegExp = Object.values(SuperCategorySlug).join('|');
var pageRegExp = '[1-9][0-9]*';

var getPaginatedRoutes = function getPaginatedRoutes(route) {
  return [route + "/page/:page(" + pageRegExp + ")", route];
};

var allCategoriesRoutes = getPaginatedRoutes('/all-categories');
var collectionRoutes = getPaginatedRoutes("/:collection(" + collectionSlugRegExp + ")");
var categoryRouteBase = "/:superCategory(" + superCategorySlugRegExp + ")/:category(" + categorySlugRegExp + ")";
var categoryRoutes = getPaginatedRoutes(categoryRouteBase + "?");
var detailPageRoutes = [categoryRouteBase + "/:slug/write-review", categoryRouteBase + "/:slug", '/_detail/:slug/write-review', '/_detail/:slug', '/_preview/:slug'];
var allReviewsPageRoutes = [categoryRouteBase + "/:slug/reviews", '/_detail/:slug/reviews'];
var CategorySearchResults = (0, _withCategoryParamValidation.default)(_SearchResults.default);
var DetailContainer = (0, _withCategoryParamValidation.default)(function (props) {
  var slug = props.match.params.slug;
  return _react.default.createElement(_DetailContainer.default, (0, _extends2.default)({
    key: slug
  }, props));
});

var NotFoundRoute = function NotFoundRoute() {
  return _react.default.createElement(_reactRhumb.NavMarker, {
    name: "NOT_FOUND_ERROR_LOAD"
  }, _react.default.createElement(_NotFoundError.default, null), _react.default.createElement(_auth.PublicOnly, null, _react.default.createElement(_DocumentHead.default, null, _react.default.createElement(_PrerenderReady.default, {
    statusCode: 404
  }))));
};

function Routes() {
  return _react.default.createElement(_reactRouterDom.Switch, null, _react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: ['/'].concat((0, _toConsumableArray2.default)(allCategoriesRoutes), (0, _toConsumableArray2.default)(collectionRoutes), (0, _toConsumableArray2.default)(categoryRoutes)),
    render: function render(props) {
      return _react.default.createElement(_Storefront.default, props, _react.default.createElement(_reactRouterDom.Switch, null, _react.default.createElement(_reactRouterDom.Route, {
        path: allCategoriesRoutes,
        component: _SearchResults.default
      }), _react.default.createElement(_reactRouterDom.Route, {
        path: collectionRoutes,
        component: _SearchResults.default
      }), _react.default.createElement(_reactRouterDom.Route, {
        path: categoryRoutes,
        component: CategorySearchResults
      }), _react.default.createElement(_reactRouterDom.Route, {
        path: "/",
        component: _AllCollections.default
      })));
    }
  }), _react.default.createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: categoryRouteBase + "/:slug/review",
    to: categoryRouteBase + "/:slug/write-review"
  }), _react.default.createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: "/_detail/:slug/review",
    to: "/_detail/:slug/write-review"
  }), _react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: [].concat(detailPageRoutes, allReviewsPageRoutes),
    render: function render(props) {
      return _react.default.createElement(DetailContainer, props, _react.default.createElement(_reactRouterDom.Switch, null, _react.default.createElement(_reactRouterDom.Route, {
        path: allReviewsPageRoutes,
        component: _AllReviewsPage.default
      }), _react.default.createElement(_reactRouterDom.Route, {
        path: detailPageRoutes,
        component: _DetailPage.default
      })));
    }
  }), _react.default.createElement(_reactRouterDom.Route, {
    component: NotFoundRoute
  }));
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/Routes.js
// module id = 659
// module chunks = 209 210 211 212